import {RootState} from "../store/store";
import {doc, getDoc} from "firebase/firestore";
import {db} from "../../firebase";
import {appInfoConverter, orderInfoConverter} from "../../firebase/converters";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {AppInfo, OrderInfo} from "./types";

export const fetchOrderInfo = createAsyncThunk<
    { orderInfo: OrderInfo },
    void, // UIDパラメタに入れるべきか？
    { state: RootState }
>("info/fetchOrderInfo", async (_, {getState, rejectWithValue}) => {
    const uid = getState().users.uid;

    const orderInfoRef = doc(db, `users/${uid}/info/orderInfo`)
        .withConverter(orderInfoConverter);
    const orderInfoSnapshot = await getDoc(orderInfoRef);

    if (orderInfoSnapshot.exists()) {
        const orderInfo = orderInfoSnapshot.data();
        return {orderInfo};
    } else {
        return rejectWithValue(`OrderInfo (uid: ${uid}) not found.`)
    }

});

export const fetchAppInfo = createAsyncThunk<
  { appInfo: AppInfo },
  void,
  {}
>('info/fetchAppInfo', async (_, {rejectWithValue}) => {
    const appInfoRef = doc(db, `info/app_info`).withConverter(appInfoConverter);

    try {
        const appInfoSnapshot = await getDoc(appInfoRef);

        if (appInfoSnapshot.exists()) {
            const appInfo = appInfoSnapshot.data();
            return {appInfo};
        } else {
            return rejectWithValue("AppInfo not found.");
        }
    } catch (e) {
        console.error(e);
        return rejectWithValue(e);
    }
});